const pictograms = require.context('./', false, /\.svg$/);
pictograms.keys().forEach(pictograms);
